import { render, staticRenderFns } from "./settings-account-available-hours.vue?vue&type=template&id=2b42c2a6&scoped=true&"
import script from "./settings-account-available-hours.vue?vue&type=script&lang=js&"
export * from "./settings-account-available-hours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b42c2a6",
  null
  
)

export default component.exports